import { Skeleton } from "@mui/material";

export default function ManagedGroupCardSkeleton() {
  return (
    <div className="bg-white rounded-2xl shadow-sm overflow-hidden">
      <Skeleton variant="rectangular" height={12} animation="wave" />
      <div className="p-5 flex flex-col gap-3">
        <Skeleton variant="text" width="70%" height={28} animation="wave" />
        <Skeleton variant="text" width="50%" animation="wave" />
        <Skeleton variant="text" width="90%" animation="wave" />
      </div>
    </div>
  );
}
